import { _js } from '@ifixit/localize';

let sdkLoaded = false;
let sdkLoading = false;
let pendingCallbacks = [];

function onSdkReady() {
   sdkLoaded = true;
   sdkLoading = false;
   pendingCallbacks.forEach(cb => cb());
   pendingCallbacks = [];
}

export function loadAppleSdk(callback) {
   if (sdkLoaded) {
      callback();
      return;
   }

   pendingCallbacks.push(callback);

   if (sdkLoading) {
      return; // Script is loading, callback will be called when ready
   }

   sdkLoading = true;

   const script = document.createElement('script');
   script.src =
      'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
   script.async = true;
   script.onload = () => {
      const currentDomain = window.location.protocol + '//' + window.location.host;
      // In popup mode, redirectURI is validated but not used for actual redirects.
      // Must match exactly what's registered in Apple Developer Console.
      window.AppleID.auth.init({
         clientId: App.appleClientId,
         scope: 'name email',
         redirectURI: currentDomain + '/Guide/User/remote_login',
         usePopup: true,
      });
      onSdkReady();
   };
   script.onerror = () => {
      sdkLoading = false;
      console.error('Failed to load Apple Sign In SDK');
   };
   document.body.append(script);
}

export function setupAppleLoginButton(loginHandler, errorHandler) {
   const appleLoginBtn = $('appleLogin');

   // If no button or no client ID configured, nothing to do
   if (!appleLoginBtn || !App.appleClientId) {
      return;
   }

   loadAppleSdk(() => {
      appleLoginBtn.removeClass('disabled');
   });

   appleLoginBtn.addEvent('click', async ev => {
      ev.stop();

      // Find the actual button element (click might be on child span)
      const btn = $('appleLogin');
      if (btn.hasClass('disabled')) {
         return;
      }
      btn.addClass('disabled');

      try {
         const response = await window.AppleID.auth.signIn();

         const apiResponse = await fetch('/api/2.0/user/login/appleLogin', {
            method: 'POST',
            headers: {
               'Content-Type': 'application/json',
            },
            body: JSON.stringify({
               identityToken: response.authorization.id_token,
               user: response.user,
            }),
         });

         const result = await apiResponse.json();

         if (result.loggedIn) {
            result.from = 'apple';
            loginHandler(result);
         } else {
            errorHandler(result.reason || _js('Unable to complete Apple login.'));
         }
      } catch (error) {
         // User cancelled or other error
         if (error?.error !== 'popup_closed_by_user') {
            errorHandler(_js('Unable to complete Apple login.'));
         }
      } finally {
         btn.removeClass('disabled');
      }
   });
}
